import { getDefaultAudioUrl, getDefaultVideoUrl } from './convertNodes.js';
import { toPlainTextBase } from './to-plain-text-base.js';
import 'ricos-schema';
import '../../../consts.js';
import '../../../convertDecorationDataToDraft-3295e0fb.js';
import 'lodash';
import '../../nodeUtils.js';
import '../../../ReadonlyNonEmptyArray-0e481d0b.js';
import '../../../string-40bcd6bf.js';
import 'uuid';
import '../../../utils.js';
import '../../generateRandomId.js';
import '../../draft/consts.js';
import '../../draft/toDraft/convertContainerData.js';
import '../../../index-71a2067e.js';
import '../../../index-205daf5f.js';
import '../../draft/toDraft/convertDraftPluginDataNoInnerRCE.js';
import '../../draft/toDraft/convertStructToJson.js';
import '../../../Either-f9cb4a7c.js';
import '../../../Record-8960daac.js';
import '../../../ReadonlyRecord-86a56753.js';
import '../../../Tuple-2f69c1c7.js';
import '../../../fp-utils-75447caf.js';
import '../../draft/struct-refined-types.js';
import '../../draft/toDraft/utils.js';
import '../../draft/emojiRegex.js';
import '../../draft/toDraft/preprocess.js';
import '../../draft/toDraft/utils/parseDocStyle.js';
import '../../../version/versioningUtils.js';
import '../../../package-d868b32f.js';

const toPlainTextSync = (content, options = {}) => {
  var _a;
  const gen = toPlainTextBase(content, options.delimiter, options.addLinksToText);
  let next = gen.next();
  while (!next.done) {
    switch (next.value.command) {
      case "getImageUrl": {
        const url = options.urlShortener ? (_a = options.urlShortener) == null ? void 0 : _a.call(options, next.value.data) : next.value.data;
        next = gen.next(url);
        break;
      }
      case "getVideoUrl": {
        const url = options.getVideoUrl ? options.getVideoUrl(next.value.data) : getDefaultVideoUrl(next.value.data);
        next = gen.next(url);
        break;
      }
      case "getVideoEmbeddedUrl": {
        const url = options.getVideoEmbeddedUrl ? options.getVideoEmbeddedUrl(next.value.data) : next.value.data;
        next = gen.next(url);
        break;
      }
      case "getAudioUrl": {
        const url = options.getAudioUrl ? options.getAudioUrl(next.value.data) : getDefaultAudioUrl(next.value.data);
        next = gen.next(url);
        break;
      }
      case "getGifUrl": {
        const url = options.getGifUrl ? options.getGifUrl(next.value.data) : next.value.data;
        next = gen.next(url);
        break;
      }
      default:
        return "";
    }
  }
  return next.value;
};

export { toPlainTextSync };
//# sourceMappingURL=toPlainTextSync.js.map
